<template>
  <div>
    <v-container>
      <v-progress-linear
        class="mt-n4"
        indeterminate
        color="primary"
        v-if="loading"
      ></v-progress-linear>
      <v-layout row wrap>
        <v-flex
          xs12
          sm6
          md4
          v-for="(project, divCount) in Projects"
          :key="project.id"
           style="padding-left:3px;padding-right: 15.6802px;"
        >
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="ma-2  project-tile projectCard"
              outlined
              :elevation="hover ? 2 : 0"
              @click="onClick(project)"
              :class="`a${divCount % 4}`"
            >
              <v-card-title style="margin-top:-9px">
                <div>
                  <span class="projectTitle">
                    {{ project.title }}
                  </span>
                  <div class="content-1">{{ project.feederData.stateName }}</div>
                </div>
              </v-card-title>
              <v-card-text>
                <div class="content">
                  <div> Analysis Type: {{ project.analysisLevel }}   </div>
                  <div>Technology: {{ project.technologyType }} </div>
                </div>
                <!-- <div class="content">Analysis Type: {{ project.analysisLevel }}</div> -->
                <!-- <div class="content">Technology: {{ project.technologyType }}</div> -->
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex v-if="!Projects || Projects.length === 0">
          <div
            class="pa-4 text-center text-subtitle1 grey--text mt-8"
            style="min-height: 200px"
          >
            No data available
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions
      class="justify-center"
      v-if="Projects && Projects.length > 0"
    >
      <v-btn
        text
        color="primary"
        class="text-capitalize"
        @click="increaseCardCount"
        :disabled="disableMore"
      >
        > View More Projects >
      </v-btn>
    </v-card-actions>
  </div>
</template>
<script>
export default {
  name: "ProjectList",
  props: ["Projects", "loading"],
  currentPage: 1,

  data: () => ({
    divCount: 0,
    readMoreActivated: false,
    noofCards: 6,
    increasedby: 3,
    disableMore: false,
  }),

  methods: {
    increaseCardCount() {
      if (this.noofCards >= this.totalCards) {
        this.disableMore = true;
        return;
      }
      this.noofCards = this.noofCards + this.increasedby;
    },
    onClick(project) {
      this.$emit("onItemClick", project);
    },
  },
};
</script>
<style scoped>
.project-tile :hover {
  cursor: pointer;
}
.a0 {
  background-color: #6bbc56;
  border-radius: 8pt;
  color: white;
  text-transform: uppercase;
  font-weight: 400;
}
.a1 {
  background-color: #43a998;
  border-radius: 8pt;
  color: white;
  text-transform: uppercase;
  font-weight: 400;
}
.a2 {
  background-color: #55af79;
  border-radius: 8pt;
  color: white;
  text-transform: uppercase;
  font-weight: 400;
}
.a3 {
  background-color: #2fa9d8;
  border-radius: 8pt;
  color: white;
  text-transform: uppercase;
  font-weight: 400;
}
.content{
  /* margin-top: -13px; */
  font-size: 11px;
  font-weight: 300;
  color: white;
  text-transform:capitalize;
  line-height : 19px;
}
.content-1{
  font-size: 16px;
  font-weight: 300;
  line-height : 22px;
  color: white;
  text-transform: capitalize;
}
.projectTitle{
  font-size : 20px;
  font-weight: 400;
  color : #FFFFFF;
}
.projectCard{
  width:260.0854px;
  height: 130.8148px;
}
</style>